import { commonRequest } from '@/utils/request'


const actions = {
  mobile: ({ commit }, data) => commonRequest({ data, url: '/dashboard/mobile' }),
  info: ({ commit }, data) => commonRequest({ data, url: '/dashboard/info' }),
}

export default {
  namespaced: true,
  actions
}
